// Keep this order aligned with the consent type options in Kleos editable-consents.
export const AVAILABLE_CONSENT_KEYS = ['privacy', 'marketing', 'allJobs', 'disclosure'];

export function resolveConsentName(questionKey: string, order: number, fallbackIndex: number): string {
  if (AVAILABLE_CONSENT_KEYS.includes(questionKey)) {
    return questionKey;
  }

  const orderedConsentName = AVAILABLE_CONSENT_KEYS[Number(order) - 1];
  return orderedConsentName || AVAILABLE_CONSENT_KEYS[fallbackIndex] || questionKey;
}
